const DEFAULT_LANGUAGE = 'en';

/** Explicit BCP 47 tags where the bare subtag is ambiguous or region-sensitive. */
const intlLocaleMap: Record<string, string> = {
  en: 'en-US',
  nl: 'nl-NL',
  fr: 'fr-FR',
  de: 'de-DE',
  es: 'es-ES',
  it: 'it-IT',
  ja: 'ja-JP',
  sv: 'sv-SE',
  pt: 'pt-PT',
  zh: 'zh-CN',
  nb: 'nb-NO',
};

export const getLanguageCode = (language?: string) =>
  language?.split('-')[0].toLowerCase() || DEFAULT_LANGUAGE;

/** BCP 47 locale for Intl number formatting (analytics only — not dates). */
export const getIntlLocale = (language?: string) => {
  const code = getLanguageCode(language);
  return intlLocaleMap[code] ?? code;
};
